var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.086 20.914l9.584 9.617c.558.525 1.411.525 1.936 0a1.387 1.387 0 000-1.937l-8.632-8.632 8.632-8.632c.525-.558.525-1.411 0-1.936-.525-.525-1.378-.525-1.936 0l-9.584 9.584c-.525.558-.525 1.411 0 1.936z",
    fill: "#FFFCFC"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wODU5IDIwLjkxNDFMMjMuNjY5NyAzMC41MzA3QzI0LjIyNzcgMzEuMDU1OSAyNS4wODEgMzEuMDU1OSAyNS42MDYxIDMwLjUzMDdDMjYuMTMxMyAzMC4wMDU2IDI2LjEzMTMgMjkuMTE5NCAyNS42MDYxIDI4LjU5NDNMMTYuOTc0MiAxOS45NjIzTDI1LjYwNjEgMTEuMzMwM0MyNi4xMzEzIDEwLjc3MjMgMjYuMTMxMyA5LjkxOSAyNS42MDYxIDkuMzkzODZDMjUuMDgxIDguODY4NzEgMjQuMjI3NyA4Ljg2ODcxIDIzLjY2OTcgOS4zOTM4NkwxNC4wODU5IDE4Ljk3NzdDMTMuNTYwNyAxOS41MzU2IDEzLjU2MDcgMjAuMzg5IDE0LjA4NTkgMjAuOTE0MVoiIGZpbGw9IiNGRkZDRkMiLz4KPC9zdmc+Cg==";
export { SvgLeftNavigation as ReactComponent };